export const MFA_SUBMIT = 'events/MFA_SUBMIT';

/**
 * @param passcode
 * @param username
 * @param mfaType
 * @param mfaVendor
 * @return {{type: string, payload: {passcode: *,username: *,mfa_type: *,mfa_vendor: *}}}
 */
export const mfaSubmit = (passcode, username, mfaType, mfaVendor) => ({
  type: MFA_SUBMIT,
  payload: {
    passcode, username, mfa_type: mfaType, mfa_vendor: mfaVendor,
  },
});
